import DtoReferencial from './DtoReferencial'

export default class DtoType extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
